import { LocationEditorProps } from '../types'
import { getLocationAccuracy } from '../utils/getLocationAccuracy'
import { useActionBarActions } from './useActionBarActions'
import { useClickAwayProps } from './useClickAwayProps'
import { useLocationEditorListItemProps } from './useLocationEditorListItemProps'
import { useLocationEditorState } from './useLocationEditorState'
import { useMenuListProps } from './useMenuListProps'
import { usePaperProps } from './usePaperProps'
import { usePopperProps } from './usePopperProps'
import { useRootProps } from './useRootProps'
import { useScrollToSelectedItem } from './useScrollToSelectedItem'
import { useTextfieldProps } from './useTextfieldProps'

export function useLocationEditor(props: LocationEditorProps) {
  const { state, dispatch } = useLocationEditorState(props)
  const { dropdownOptions, dropdownSelectedIndex } = state

  const { textFieldProps, textFieldContainerRef } = useTextfieldProps(dispatch, state, props)

  const rootProps = useRootProps(props)

  const paperProps = usePaperProps(textFieldContainerRef)
  const { popperProps, popperRef } = usePopperProps(state, textFieldContainerRef)
  const locationEditorListItemProps = useLocationEditorListItemProps(dispatch)
  const clickAwayProps = useClickAwayProps(dispatch)
  const menuListProps = useMenuListProps()
  const actionBarProps = useActionBarActions(props, dispatch)

  useScrollToSelectedItem(state, popperRef)

  const cardType = props.loading
    ? 'loading'
    : props.assets.length > 0
      ? 'list'
      : state.textFieldValue.length <= props.queryMinLength || !state.textFieldDirty
        ? 'set-query'
        : 'no-assets'

  return {
    menuListProps,
    textFieldProps,
    rootProps,
    popperProps,
    clickAwayProps,
    paperProps,
    dropdownOptions,
    locationEditorListItemProps,
    dropdownSelectedIndex,
    cardType,
    locationAccuracy: getLocationAccuracy(props.location),
    actionBarProps,
  }
}
